import React from "react";
import HeroSection from "./herosection/HeroSection";
import Technology from "./technology/Technology";
import Custom from "./custom/Custom";
import Testimonials from "./testimonials/Testimonials";
import Trust from "./trust/Trust";
import Project from "./project/Project";

export default function MachineLearning() {
  return (
    <div id="machine">
      <HeroSection />
      <Technology />
      <Custom />
      <Trust />
      <Testimonials />
      <Project />
    </div>
  );
}
